import { BeforeInsert, Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite, EntiteStatique } from './index';

@EntiteStatique()
@Entity('erreur')
export class Erreur implements BaseEntite {
    static key = 'erreurs';
    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    name: string;
    @Column()
    message: string;
    @Column({ type: 'timestamp', nullable: true })
    created_at: string;

    @Column({ nullable: true })
    stack?: string;

    static fromError(e: Error): Erreur {
        const result = new Erreur();
        result.name = e.name;
        result.stack = e.stack;
        result.message = e.message;
        return result;
    }

    @BeforeInsert()
    updateCreatedAt(): void {
        this.created_at = new Date().toUTCString();
    }
}
